import { render, staticRenderFns } from "./DiscussionPoints.vue?vue&type=template&id=2ac02576&"
import script from "./DiscussionPoints.vue?vue&type=script&lang=js&"
export * from "./DiscussionPoints.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionPoints.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports